import React from 'react'
import { Spinner } from 'react-bootstrap'

const Loading = () => {
  return (
  <div id="splash-screen" className="splash-screen">
      <span>
        {/* spinner bootstrap */}
        <Spinner animation="border" style={{color: "#033d68"}} variant="" />
      </span>
  </div>
  )
}

export default Loading